






















import { Component, Vue } from 'vue-property-decorator';
import UserTable from '@/components/UserTable.vue';
import UserAdd from '@/components/UserAdd.vue';
import { User } from '@/interfaces/user.interface';
import { namespace } from 'vuex-class';

const usersModule = namespace('users');

@Component({
  components: {UserAdd, UserTable}
})
export default class UsersView extends Vue {
  @usersModule.Action fetchUsers: any;
  @usersModule.Action setUsersFilter: any;

  get search(): string {
    return this.$store.state.users.userFilters.search;
  }

  set search(search: string) {
    this.setUsersFilter({search});
  }

  get users(): User[] {
    return this.$store.state.users.users;
  }

  mounted() {
    if (!this.users.length) {
      this.fetchUsers();
    }
  }
}
